import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link as BaseLink } from 'react-router-dom';
import { useSearchParams } from 'src/utils/useSearchParams';
import mixCustomizationParam from 'src/utils/mixCustomizationParam';
import type { ToType } from 'src/utils/mixCustomizationParam';

type Props = {
  to: ToType;
  [x: string]: any;
};

// необходимо, чтобы при любом переходе сохранялся параметр customization, т.к. с его помощью определяется
// внешний вид некоторых страниц для банков партнеров и для пользователя нежелательно при каком-либо переходе
// в агенте внезапно получить дефолтное отображение сайта
const Link: React.FC<Props> = ({ to, ...rest }) => {
  const [searchParams] = useSearchParams();
  const customization = searchParams.get('customization');
  const mixedTo = mixCustomizationParam(to, customization);

  return <BaseLink {...rest} to={mixedTo} />;
};

export default Link;
